export default '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\
  <path d="M14.355 18.7L5.684 10.03L14.355 1.359" stroke="var(--color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\
</svg>'
